import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import { AccountResponse } from "../../types";


type AuthState = {
  accessToken: string | null;
  account: AccountResponse | null;
  email: string | null;
  isAuthenticated: boolean;
};


type LoginPayload = {
  access: string;
  user: AccountResponse;
};


const initialState: AuthState = {
  accessToken: null,
  account: null,
  email: null,
  isAuthenticated: false,
};


const authSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {
    /**
     * Store the complete response from:
     *
     * POST /auth/login/
     *
     * The refresh token is not stored in Redux because Django
     * places it in an HTTP-only cookie.
     */
    loginSuccess(
      state,
      action: PayloadAction<LoginPayload>
    ) {
      state.accessToken = action.payload.access;
      state.account = action.payload.user;
      state.isAuthenticated = true;
    },

    /**
     * Replace only the access token after a successful
     * refresh-token request.
     */
    setAccessToken(
      state,
      action: PayloadAction<string>
    ) {
      state.accessToken = action.payload;
      state.isAuthenticated = true;
    },

    /**
     * Update user/profile information without replacing the token.
     * This can be used after loading a current-user endpoint.
     */
    setAccount(
      state,
      action: PayloadAction<AccountResponse>
    ) {
      state.account = action.payload;
      state.isAuthenticated = true;
    },
    setEmail(
      state: AuthState,
      action: PayloadAction<{ email: string}>
    ) {
      state.email = action.payload.email;
    },

    /**
     * Clear all frontend authentication state.
     *
     * Your logout API should also clear the HTTP-only
     * refresh-token cookie.
     */
    logout(state) {
      state.accessToken = null;
      state.account = null;
      state.isAuthenticated = false;
    },
  },
});


export const {
  loginSuccess,
  setAccessToken,
  setAccount,
  setEmail,
  logout,
} = authSlice.actions;

export default authSlice.reducer;